/**
 * Configuración de las marcas soportadas para publicar un Trip Plan al cliente.
 * ET (Espíritu Travel) es el default. VDV (Viaja de Verdad) es la marca alternativa.
 *
 * Cada bloque incluye: logos (dos versiones para fondo claro/oscuro),
 * nombre público, email, teléfono, web y color primario para acentos.
 * El visor (`PublicTripViewer`, `TravelDocViewer`) y el PDF leen `snap.brand`
 * y cogen la configuración de aquí.
 */
export const BRANDS = {
  et: {
    id: "et",
    name: "Espíritu Travel",
    tagline: "Feel part of the world",
    logo_navy: "/brand/et-logo-navy.png",   // versión oscura para fondos claros
    logo_sand: "/brand/et-logo-sand.png",   // versión clara para fondos oscuros
    logo_white: "/brand/et-logo-white.png",
    email: "hola@espiritutravel.com",
    phone: "+34 911 23 45 67",
    whatsapp: "+34 600 123 456",
    website: "www.espiritutravel.com",
    website_url: "https://www.espiritutravel.com",
    // Dominio bajo el que se sirven los itinerarios públicos ET.
    // En producción apunta a la app SOFI (subdominio dedicado).
    public_host: "itinerary.espiritutravel.com",
    emergency: "+34 600 999 000",
    color_primary: "#121b28",
  },
  vdv: {
    id: "vdv",
    name: "Viaja de Verdad",
    tagline: "Focused on you",
    logo_navy: "/brand/vdv-logo-navy.webp",
    logo_sand: "/brand/vdv-logo-sand.webp",
    logo_white: "/brand/vdv-logo-sand.webp",
    email: "info@viajadverdad.com",
    phone: "+34 91 198 01 28",
    whatsapp: "+34 91 198 01 28",
    website: "viajadverdad.com",
    website_url: "https://viajadverdad.com",
    public_host: "itinerary.viajadverdad.com",
    emergency: "+34 91 198 01 28",
    color_primary: "#121b28",
  },
};

export function getBrand(id) {
  return BRANDS[id] || BRANDS.et;
}

/**
 * Devuelve la URL pública completa para un token de viaje bajo la marca dada.
 *
 * Comportamiento del flag `REACT_APP_MULTI_HOST`:
 *   - Si vale `"1"` (o `"true"`) → siempre usa el `public_host` de la marca
 *     (`itinerary.espiritutravel.com` / `itinerary.viajadverdad.com`).
 *   - En cualquier otro caso → usa el `origin` actual del navegador. Esto es
 *     lo que queremos hasta tener los DNS de marca activos: todos los links
 *     salen bajo el único dominio linkeado en Emergent (p.ej. `sofi.viajadverdad.com`).
 */
export function getPublicTripUrl(brandId, token, path = "trip", fallbackOrigin = null) {
  const b = getBrand(brandId);
  const multi = String(process.env.REACT_APP_MULTI_HOST || "").toLowerCase();
  const multiHostOn = multi === "1" || multi === "true";
  const currentOrigin = fallbackOrigin || (typeof window !== "undefined" ? window.location.origin : "");
  if (multiHostOn) {
    if (currentOrigin && currentOrigin.includes(b.public_host)) return `${currentOrigin}/${path}/${token}`;
    return `https://${b.public_host}/${path}/${token}`;
  }
  // Multi-host desactivado: los links se sirven bajo el mismo dominio donde corre la app.
  return currentOrigin ? `${currentOrigin}/${path}/${token}` : `/${path}/${token}`;
}

export const BRAND_OPTIONS = [
  { value: "et", label: "Espíritu Travel", short: "ET" },
  { value: "vdv", label: "Viaja de Verdad", short: "VDV" },
];
